// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TextSearchPattern } from "../text-search-pattern";
import { SearchRequestBase } from "./base/search-request-base";

export class HtmlContentSearchRequest extends SearchRequestBase {
	public NameSearchPattern: TextSearchPattern = new TextSearchPattern();
}